import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { Switch as S } from "radix-ui";
import { cn } from "@/lib/cn";

export const Switch = forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<typeof S.Root>>(function Switch({ className, ...props }, ref) {
  return (
    <S.Root
      ref={ref}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-pill bg-slate-300 transition-colors data-[state=checked]:bg-primary disabled:opacity-50 before:absolute before:-inset-2.5 before:content-['']",
        className,
      )}
      {...props}
    >
      <S.Thumb className="block size-5 translate-x-0.5 rounded-full bg-white shadow transition-transform data-[state=checked]:translate-x-[22px]" />
    </S.Root>
  );
});

/** Switch with a clickable label row (44px target). */
export function SwitchRow({ label, hint, checked, onCheckedChange, id, disabled }: { label: string; hint?: string; checked: boolean; onCheckedChange: (v: boolean) => void; id: string; disabled?: boolean }) {
  return (
    <div className="flex min-h-11 items-center justify-between gap-4 py-1">
      <label htmlFor={id} className="min-w-0 flex-1 cursor-pointer">
        <span className="block text-sm font-medium text-slate-800">{label}</span>
        {hint ? <span className="block text-[13px] text-slate-500">{hint}</span> : null}
      </label>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
    </div>
  );
}
